/*
 * module.js - The description of the module.
 */

Fundu.Utils.Simulate = (function($) {

    // State
    ///////////////////////////
    var _isInitialized = false;
    var _simulationToggles = false;
    var _disableSimulation = false;

    // Properties
    ///////////////////////////

    // Private Methods
    ///////////////////////////


    var toggleSimulation = function(ev){
        if(ev)
            ev.preventDefault();

        var value = $(this).data('simulate');
        if(typeof value !== "string") return false;

        if(value !== "" && value !== "disable" && value !== "none" ){
            if(Fundu.Helpers.Validate.simulation(value)){
                if(!$("body").hasClass('simulate')){
                    $("body").addClass('simulate');
                }

                var simulations = Fundu.Helpers.Validate.Get.simulations().join(" ");
                simulations.replace(value + ", ", ""); // Incase the class is at the beginning or in the middle
                simulations.replace(value, ""); // Incase the class is at the end

                $("body").removeClass(simulations);
                $("body").addClass(value);

                _simulationToggles.removeClass('active');
                $(this).addClass('active');
            }
        }
        else {
            var simulations = Fundu.Helpers.Validate.Get.simulations().join(" ");
            $("body").removeClass('simulate ' + simulations);

            _simulationToggles.removeClass('active');
            _disableSimulation.addClass("active");
        }
    }

    // Init
    ///////////////////////////
    var initialize = function() {
        _simulationToggles = $(".simulation .toggle.simulate");
        _disableSimulation = $(".simulation .disable.toggle.simulate");

        if(_simulationToggles.length === 0){
            return false;
        } else {
            _simulationToggles.on('click', toggleSimulation);
        }

        return true;
    }

    // Public Methods
    ///////////////////////////

    // Reveal public methods
    return {
        init: initialize
    }

})(jQuery);
